import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import * as Urls from 'src/constants/EndpointUrls';
import { Pulldown } from 'jbc-front/components/icons';
import { redirectTo } from 'src/utils/Http';
import styles from './ActionSection.scss';
import { withTranslation } from 'react-i18next';

const AllowanceDeductionsMethod = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    render() {
      const { downloadTemplateCsvPageUrl, isConfirmed } = this.props;

      return (
        <div className={styles.baloonWrap}>
          <div className={styles.baloon}>
            <ul className={styles.links}>
              <li>
                <a
                  disabled={!isConfirmed}
                  className={isConfirmed ? null : styles.disabled}
                  onClick={() => redirectTo(Urls.SHOW_ALLOWANCE_DEDUCTIONS_PAY)}
                  role="presentation"
                >
                  <Pulldown size={8} />{this.props.t('features.EmployeePays.components.AllowanceDeductionsMethod.Provision_and_deduction_list')}
                </a>
              </li>
              <li>
                <a
                  className={isConfirmed ? styles.disabled : undefined}
                  onClick={() => redirectTo(downloadTemplateCsvPageUrl)}
                  disabled={isConfirmed}
                  role="presentation"
                >
                  <Pulldown size={8} />{this.props.t('features.EmployeePays.components.AllowanceDeductionsMethod.Provision_and_deduction_items_CSV_import')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      );
    }
  }
);

export default withTranslation('translation')(AllowanceDeductionsMethod);
